module.exports = __webpack_public_path__ + "img/zoom-minus.4045e001.svg";